import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppConstant } from '../../../../../../../Assests/AppConstant';
import { getUserSelector } from '../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { sagaActions } from '../../../../../../../../sagas/sagaActions';
import { getWhMetaDataReducerSlice } from '../../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import { toast } from 'react-toastify';
import { showAlert, initiateSearch, changeFormatWithoutTz } from '../../../../../../../Assests/Utility';
import moment from "moment";
import './DockList.css';
import DrilldownTableSS from '../../../../../Components/Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import CustomButtonSS from '../../../../../../Common/CustomButton/CustomButtonSS';
import EditIcon from '../../../../../../../Assests/Images/edit-icon-new.png'
import SSPopup from '../../../../../../Common/Popup/SSPopup/SSPopup';
import _ from 'lodash';


const DockCapacityMangementList = (props) => {
  const dispatch = useDispatch();
  const {
    themeSelected,
    allowPermissionE = true,
    editDockAction,
    searchStr,
    whObj,
  } = props;
  const navigate = useNavigate();
  const user = useSelector(getUserSelector);
  const { selectedWarehouse, cu_id } = user;
  const whMetaReducer = useSelector(getWhMetaDataReducerSlice);
  const {
    whMetaDocksList,
    operationObj,
    arrangeOrder,
    arrangeKey,
    preCheckList,
    dockConflictObj,
    isLoading,
    capacityManagementList,
  } = whMetaReducer;
  const [isListLoading, setListLoading] = useState(false);
  const [metaDockArr, setMetaDockArr] = useState([]);
  const [currentItemIndex, setCurrentItemIndex] = useState("NA");
  const [currentDeleteIndex, setCurrentDeleteIndex] = useState("NA");
  const [selectedObj, setSelectedObj] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [deleteClick, setOnDeleteClick] = useState(false);
  const [showPreCheckModal, setShowPreCheckModal] = useState(false);

  useEffect(() => {
    if (preCheckList && preCheckList.length > 0) {
      setCurrentItemIndex("NA");
      setCurrentDeleteIndex("NA");
    }
  }, [preCheckList]);



  const dockTimeslotsTitleDD = [
    { id: "Name", name: AppConstant.poManagement.tableHeader.dock },

    {
      id: "CreatedDate",
      name: AppConstant.superUserAdmin.companyGroup.tableHeader.createdOn,
    },
    {
      id: "status",
      name: AppConstant.superUserAdmin.companyGroup.tableHeader.status,
    },
    {
      id: "",
      name: AppConstant.superUserAdmin.warehouseAdmin.warehouseTable
        .actionsColTitle,
    },
  ];



  useEffect(() => {
    if (operationObj.type) {
      switch (operationObj.type) {
        case "Update status":
          if (operationObj.status) {
            handleApiResponse(
              AppConstant.notifications.dataAddedSuccess,
              AppConstant.smartScheduler.docks.updateDockStatusSuccess
            );
          } else {
            handleApiResponse(
              AppConstant.commonStrings.failure,
              AppConstant.smartScheduler.docks.updateDockStatusFailure
            );
          }
          break;
        case "Delete Dock":
          if (operationObj.status) {
            handleApiResponse(
              AppConstant.notifications.dataAddedSuccess,
              AppConstant.smartScheduler.docks.deleteDockSuccess
            );
          } else {
            handleApiResponse(
              AppConstant.commonStrings.failure,
              AppConstant.smartScheduler.docks.deleteDockFailure
            );
          }
          break;
        case "Fetch":
          setListLoading(false);
          // setMetaDockArr([]);
          if (operationObj.status) {
          } else {
            handleApiResponse(
              AppConstant.commonStrings.failure,
              AppConstant.smartScheduler.docks.updateDockStatusFailure
            );
          }
          break;
        default:
      }
    }
  }, [operationObj]);

  const handleApiResponse = (result, message) => {
    setListLoading(false);
    setCurrentItemIndex("NA");
    setCurrentDeleteIndex("NA");
    if (result === AppConstant.notifications.dataAddedSuccess) {
      showAlert(toast.TYPE.SUCCESS, message, themeSelected);
     fetchDockCapacityList();
    } else {
      showAlert(toast.TYPE.ERROR, message, themeSelected);
    }
    dispatch({ type: sagaActions.RESET_SS_PO_OPERATION_OBJ });
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //  fetchDockCapacityList();
  //   }, 0);
  // }, []);

  const fetchDockCapacityList = () => {
      const operationObj = {
        type: "Fetch",
        status: "",
      };
      dispatch({
        type: sagaActions.GET_CAPACITY_MANAGEMENT_DETAILS,
        payload: { CRUDTYPE: "S", IDWarehouse: selectedWarehouse.ID },
        operationObj: operationObj,
      });
  }

  useEffect(() => {
    if (capacityManagementList && capacityManagementList.length) {
      setListLoading(false);
      setCurrentItemIndex("NA");
      setCurrentDeleteIndex("NA");
      setMetaDockArr( formatDockSlotsData(capacityManagementList));
    }
  }, [capacityManagementList]);

  const formatDockSlotsData = (data) => {
    const groupByDock = _.groupBy(data, "IDDock");
    const formattedData = Object.keys(groupByDock).map((key) => {
        const dockGroup = groupByDock[key];
        const dockName = dockGroup[0].DockName;
        const createdDate = dockGroup[0].CreatedOn;
        const status = dockGroup[0].Status;
        return {
          IDWarehouse: dockGroup[0].IDWarehouse,
          IDDock: dockGroup[0].IDDock,
          Name: dockName,
          CreatedDate: createdDate,
          Status: status,
          slots: dockGroup,
        };
        })

        return formattedData
  }

  useEffect(() => {
    if (searchStr.length > 3) {
      const searchedArr = initiateSearch(
        formatDockSlotsData(capacityManagementList),
        searchStr,
        "GroupName"
      );
      setMetaDockArr(searchedArr);
    } else if (searchStr === "") {
      setMetaDockArr(formatDockSlotsData(capacityManagementList));
    }
  }, [searchStr]);





  /**
   * Helper function
   * @param {*} data
   * @param {*} index
   */
  const deleteHandler = (data, index) => {
    setSelectedObj(data);
    setSelectedIndex(index);
   setShowDeleteModel(true);
  };

  /**
   * Function is used to hadle onclick popup button
   */
  const popupBtnHandler = (text) => {
    if (text === AppConstant.commonStrings.no) {
      setShowDeleteModel(false);
      isLoading(false);
      setSelectedObj(null);
      setSelectedIndex(null);
      setCurrentDeleteIndex("NA");
    } else {
      setCurrentDeleteIndex(selectedIndex);

 const payload = {
   IDWarehouse: selectedObj.IDWarehouse,
   IDDock: selectedObj.IDDock,
   CRUDTYPE: "DD",
 };
 const operationObj = {
   type: "Delete Dock",
   status: "",
 };
 dispatch({
   type: sagaActions.GET_CAPACITY_MANAGEMENT_DETAILS,
   payload: payload,
   operationObj: operationObj,
 });
    }
    setShowDeleteModel(false);
  };
  /**
   * Function used to create pop up dialog box
   * @returns
   */
  const showDeleteConfirmation = () => {
    const popupObj = {
      id: "showDeleteConfirmation",
      modalLabel: "showDeleteConfirmation",
      showClose: true,
      showfooter: true,
      showHeader: true,
      sendDriverNotification: false,
      modalSize: "md",
      title: AppConstant.smartScheduler.dockCapacityMangement.deleteDockCapacityTitle,
      bodyText: `${AppConstant.commonStrings.areYouSure} ${AppConstant.smartScheduler.dockCapacityMangement.deleteDockCapacityTitle}`,
      subText: "",
      keyboard: false,
      backdrop: "static",
      footerBtn: {
        btn1: {
          show: true,
          text: AppConstant.commonStrings.yes,
        },
        btn2: {
          show: true,
          text: AppConstant.commonStrings.no,
        },
      },
    };

    return (
      <SSPopup
        {...popupObj}
        popupBtnHandler={(text) => {
          popupBtnHandler(text);
        }}
        closepopup={() => {
          setShowDeleteModel(false);
          setCurrentDeleteIndex("NA");
        }}
        themeSelected={themeSelected}
        showModal={showDeleteModel}
      />
    );
  };

  const disableAction = (data, index) => {
    setCurrentItemIndex(index); 
            const payload = {
              IDWarehouse: data.IDWarehouse,
              IDDock: data.IDDock,
              CRUDTYPE: "ED",
              Status: !data.Status,
            };
            const operationObj = {
              type: "Update status",
              status: "",
            };
            dispatch({
              type: sagaActions.GET_CAPACITY_MANAGEMENT_DETAILS,
              payload: payload,
              operationObj: operationObj,
            });
  }

  const actionsButton = (groupObj, index) => {
    return (
      <div>
        <span className="d-flex justify-content-center gap-2 align-items-center">
          <img
            src={EditIcon}
            alt="edit"
            className="editIconPO-ss"
            data-bs-toggle="modal"
            data-bs-target={`#createCompanyGroupFormPopup1`}
            disabled={allowPermissionE ? "" : "disabled"}
            onClick={() => editDockAction(groupObj, index)}
          />
          <CustomButtonSS
            disabled={false}
            isLoading={
              currentDeleteIndex !== "NA" && currentDeleteIndex === index
                ? true
                : false
            }
            className={`no-border no-bg`}
            onClick={() => {
              deleteHandler(groupObj, index);
            }}
            isIcon={true}
            iconClass={"fa-regular fa-trash-can fa-lg"}
          />
          <CustomButtonSS
            isLoading={
              currentItemIndex !== "NA" && currentItemIndex === index
                ? true
                : false
            }
            title={`${
              !groupObj.Status
                ? AppConstant.commonStrings.enable
                : AppConstant.commonStrings.disable
            }`}
            className={`${
              !groupObj.Status ? " btnEnable-ss" : "btnDisable-ss"
            } `}
            onClick={() => disableAction(groupObj, index)}
          />
        </span>
      </div>
    );
  };



  const formatListDataDrillDown = (data) => {
    return data.map((el, index) => {
      return {
        id: index,
        0: el.Name || "-",
       
        1:
          `${moment(el.CreatedDate).format(
            AppConstant.commonStrings.MM_DD_YYYY_dateFormat
          )}\n${moment(el.CreatedDate).format(
            AppConstant.commonStrings.HH_mm_dateFormat
          )}` || "-",
        2: el.Status ? "Enabled" : "Disabled",
        3: actionsButton(el, index),
      };
    });
  };

  /**
   * Dock conflict Precheck pop up
   * @returns
   */
  const showPreCheck = () => {
    const popupObj = {
      id: "adminUpdateOperationPreCheck",
      modalLabel: "adminUpdateOperationPreCheck",
      showClose: true,
      showfooter: true,
      showHeader: true,
      sendDriverNotification: false,
      modalSize: "md",
      title: AppConstant.smartScheduler.docks.deleteDockTitle,
      bodyText: AppConstant.smartScheduler.docks.preCheckBockerMsg,
      subText: "",
      keyboard: false,
      backdrop: "static",
      footerBtn: {
        btn1: {
          show: true,
          text: AppConstant.commonStrings.viewDetailsStr,
        },
        btn2: {
          show: false,
          text: AppConstant.commonStrings.close,
        },
      },
    };

    return (
      <SSPopup
        {...popupObj}
        popupBtnHandler={(text) => {
          popupPreCheckBtnHandler(text);
        }}
        closepopup={() => {
          closePreCheckpopup();
        }}
        themeSelected={themeSelected}
        showModal={showPreCheckModal}
      />
    );
  };

  /**
   * function used to hit make API call
   * @param {*} text
   */
  const popupPreCheckBtnHandler = (text) => {
    if (text === AppConstant.commonStrings.viewDetailsStr) {
      //goto the new dock conflict component
      const data = {
        IDWarehouse: selectedObj.IDWarehouse,
        ID: selectedObj.ID,
      };
      navigate("/dockconflict", { state: { dockObj: data } });
    } else {
      setShowPreCheckModal(false);
    }
  };

  const closePreCheckpopup = () => {
    setShowPreCheckModal(false);
    setCurrentDeleteIndex("NA");
  };

  return (
    <>
      <DrilldownTableSS
        themeSelected={themeSelected}
        bodyData={metaDockArr.length && formatListDataDrillDown(metaDockArr)}
        titleData={dockTimeslotsTitleDD}
        showCollapse={false}
        showInput={false}
        showSort={true}
        arrangeOrder={arrangeOrder}
        arrangeKey={arrangeKey}
        drillDownReport={metaDockArr}
        initiateDrillDownReport={isLoading}
        loaderArray={4}
        sortingAction={sagaActions.SORT_WH_META_TABLE_ACTION}
        subRoot={{ pathName: "whMetaDocksArr" }}
        showUTCTime={false}
      />
      {showDeleteConfirmation()}
      {showPreCheck()}
    </>
  );
};

export default DockCapacityMangementList;